/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import {
  Button,
  Divider,
  Flex,
  Heading,
  Icon,
  SelectField,
  Text,
  TextAreaField,
  TextField,
  View,
} from "@aws-amplify/ui-react";
import MyIcon from "./MyIcon";
export default function DocumentViewCard(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="0"
      direction="row"
      width="900px"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "DocumentViewCard")}
      {...rest}
    >
      <Flex
        gap="24px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        grow="1"
        shrink="1"
        basis="0"
        position="relative"
        padding="32px 32px 32px 32px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "Card Area")}
      >
        <Heading
          width="unset"
          height="unset"
          shrink="0"
          alignSelf="stretch"
          level="1"
          children="Document"
          {...getOverrideProps(overrides, "dvcHeader")}
        ></Heading>
        <Flex
          gap="10px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "dvcAttachmentView")}
        >
          <Divider
            width="unset"
            height="1px"
            shrink="0"
            alignSelf="stretch"
            size="small"
            orientation="horizontal"
            {...getOverrideProps(overrides, "dvcDivider39381726")}
          ></Divider>
          <Flex
            gap="10px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "dvcAttachmentContainer")}
          >
            <Flex
              gap="6px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              grow="1"
              shrink="1"
              basis="0"
              alignSelf="stretch"
              position="relative"
              padding="9px 9px 9px 9px"
              {...getOverrideProps(overrides, "dcViewRow40216692")}
            >
              <SelectField
                width="300px"
                height="unset"
                label="Document Type"
                shrink="0"
                placeholder="Placeholder"
                size="default"
                isDisabled={false}
                labelHidden={false}
                variation="default"
                {...getOverrideProps(overrides, "dvcDocumentTypeSelect")}
              ></SelectField>
              <TextField
                width="300px"
                height="unset"
                label="Document Date"
                shrink="0"
                placeholder="Placeholder"
                size="default"
                isDisabled={false}
                labelHidden={false}
                variation="default"
                {...getOverrideProps(overrides, "dvcDocumentDateTextField")}
              ></TextField>
              <TextAreaField
                width="300px"
                height="unset"
                label="Description"
                shrink="0"
                placeholder="Placeholder"
                size="default"
                isDisabled={false}
                labelHidden={false}
                variation="default"
                {...getOverrideProps(
                  overrides,
                  "dvcDocumentDescriptionTextArea"
                )}
              ></TextAreaField>
            </Flex>
            <Flex
              gap="6px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              grow="1"
              shrink="1"
              basis="0"
              alignSelf="stretch"
              position="relative"
              padding="9px 9px 9px 9px"
              {...getOverrideProps(overrides, "dcViewRow40216892")}
            >
              <Heading
                width="unset"
                height="unset"
                shrink="0"
                alignSelf="stretch"
                level="5"
                children="Attachments"
                {...getOverrideProps(overrides, "dvcAttachmentHeader")}
              ></Heading>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "dvcAttachmentItem39381709")}
              >
                <View
                  width="78px"
                  height="78px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "dvcAttachmentIcon39381823")}
                >
                  <Icon
                    width="46.41px"
                    height="39.34px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.411521911621094,
                      height: 39.3427734375,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.4115 0L46.4115 39.3428L0 39.3428L0 0Z",
                        fill: "rgba(225,240,255,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="23.42%"
                    bottom="26.14%"
                    left="20.75%"
                    right="19.75%"
                    {...getOverrideProps(overrides, "Vector39381824")}
                  ></Icon>
                  <Icon
                    width="39.04px"
                    height="21.39px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 39.0380859375,
                      height: 21.38906478881836,
                    }}
                    paths={[
                      {
                        d: "M1.27207 21.1453L0 19.8885L18.9668 0L39.0381 20.0941L37.8117 21.3891L19.0125 2.54414L1.27207 21.1453Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="47.7%"
                    bottom="24.88%"
                    left="20.78%"
                    right="29.17%"
                    {...getOverrideProps(overrides, "Vector39381825")}
                  ></Icon>
                  <Icon
                    width="19.98px"
                    height="13.56px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 19.979881286621094,
                      height: 13.55859375,
                    }}
                    paths={[
                      {
                        d: "M18.8449 13.5586L5.88047 2.45274C4.35703 4.01426 1.43203 7.01543 1.11972 7.26679L0.00761533 5.85761L0 5.86523C0.304688 5.59863 3.34394 2.49082 5.1873 0.59414L5.76621 0L19.9799 12.1799L18.8449 13.5586Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="50.8%"
                    bottom="31.82%"
                    left="54.63%"
                    right="19.76%"
                    {...getOverrideProps(overrides, "Vector39381826")}
                  ></Icon>
                  <Icon
                    width="7.53px"
                    height="7.65px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 7.52578067779541,
                      height: 7.647657871246338,
                    }}
                    paths={[
                      {
                        d: "M0 3.82383C0 4.83797 0.396442 5.81058 1.10212 6.52768C1.8078 7.24479 2.76491 7.64766 3.76289 7.64766C4.76087 7.64766 5.71798 7.24479 6.42365 6.52768C7.12933 5.81058 7.52578 4.83797 7.52578 3.82383C7.52578 2.80969 7.12933 1.83708 6.42365 1.11997C5.71798 0.402867 4.76087 0 3.76289 0C2.76491 0 1.8078 0.402867 1.10212 1.11997C0.396442 1.83708 0 2.80969 0 3.82383Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="31.67%"
                    bottom="58.53%"
                    left="59.61%"
                    right="30.74%"
                    {...getOverrideProps(overrides, "Vector39381827")}
                  ></Icon>
                  <Icon
                    width="47.92px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 47.91972351074219,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M46.2211 0L47.9197 0L47.9197 41.3994L46.2211 41.3994L46.2211 0ZM0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.74%"
                    right="18.83%"
                    {...getOverrideProps(overrides, "Vector39381828")}
                  ></Icon>
                  <Icon
                    width="1.7px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 1.6986329555511475,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M0 0L1.69863 0L1.69863 41.3994L0 41.3994L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.42%"
                    right="78.4%"
                    {...getOverrideProps(overrides, "Vector39381829")}
                  ></Icon>
                  <Icon
                    width="46.22px"
                    height="1.72px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.22109603881836,
                      height: 1.721482515335083,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="73.18%"
                    bottom="24.61%"
                    left="19.74%"
                    right="21.01%"
                    {...getOverrideProps(overrides, "Vector39381830")}
                  ></Icon>
                </View>
                <Flex
                  gap="6px"
                  direction="column"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="flex-start"
                  grow="1"
                  shrink="1"
                  basis="0"
                  position="relative"
                  padding="0px 10px 0px 10px"
                  {...getOverrideProps(overrides, "dcViewRow39381720")}
                >
                  <Button
                    width="unset"
                    height="unset"
                    justifyContent="flex-start"
                    padding="0px 0px 0px 0px"
                    shrink="0"
                    size="small"
                    isDisabled={false}
                    variation="link"
                    children="MRI_Brain_Scan_Top_View"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentTitle39381721"
                    )}
                  ></Button>
                  <Text
                    fontFamily="Inter"
                    fontSize="12px"
                    fontWeight="600"
                    color="rgba(0,85,102,1)"
                    lineHeight="12px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    alignSelf="stretch"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Type: Video"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentType39381722"
                    )}
                  ></Text>
                  <Flex
                    gap="6px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentActions39381723"
                    )}
                  >
                    <MyIcon
                      width="24px"
                      height="24px"
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      overflow="hidden"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      type="delete"
                      {...getOverrideProps(overrides, "dcIconDelete39381724")}
                    ></MyIcon>
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "dvcAttachmentItem39391888")}
              >
                <View
                  width="78px"
                  height="78px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "dvcAttachmentIcon39391889")}
                >
                  <Icon
                    width="46.41px"
                    height="39.34px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.411521911621094,
                      height: 39.3427734375,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.4115 0L46.4115 39.3428L0 39.3428L0 0Z",
                        fill: "rgba(225,240,255,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="23.42%"
                    bottom="26.14%"
                    left="20.75%"
                    right="19.75%"
                    {...getOverrideProps(overrides, "Vector39391890")}
                  ></Icon>
                  <Icon
                    width="39.04px"
                    height="21.39px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 39.0380859375,
                      height: 21.38906478881836,
                    }}
                    paths={[
                      {
                        d: "M1.27207 21.1453L0 19.8885L18.9668 0L39.0381 20.0941L37.8117 21.3891L19.0125 2.54414L1.27207 21.1453Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="47.7%"
                    bottom="24.88%"
                    left="20.78%"
                    right="29.17%"
                    {...getOverrideProps(overrides, "Vector39391891")}
                  ></Icon>
                  <Icon
                    width="19.98px"
                    height="13.56px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 19.979881286621094,
                      height: 13.55859375,
                    }}
                    paths={[
                      {
                        d: "M18.8449 13.5586L5.88047 2.45274C4.35703 4.01426 1.43203 7.01543 1.11972 7.26679L0.00761533 5.85761L0 5.86523C0.304688 5.59863 3.34394 2.49082 5.1873 0.59414L5.76621 0L19.9799 12.1799L18.8449 13.5586Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="50.8%"
                    bottom="31.82%"
                    left="54.63%"
                    right="19.76%"
                    {...getOverrideProps(overrides, "Vector39391892")}
                  ></Icon>
                  <Icon
                    width="7.53px"
                    height="7.65px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 7.52578067779541,
                      height: 7.647657871246338,
                    }}
                    paths={[
                      {
                        d: "M0 3.82383C0 4.83797 0.396442 5.81058 1.10212 6.52768C1.8078 7.24479 2.76491 7.64766 3.76289 7.64766C4.76087 7.64766 5.71798 7.24479 6.42365 6.52768C7.12933 5.81058 7.52578 4.83797 7.52578 3.82383C7.52578 2.80969 7.12933 1.83708 6.42365 1.11997C5.71798 0.402867 4.76087 0 3.76289 0C2.76491 0 1.8078 0.402867 1.10212 1.11997C0.396442 1.83708 0 2.80969 0 3.82383Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="31.67%"
                    bottom="58.53%"
                    left="59.61%"
                    right="30.74%"
                    {...getOverrideProps(overrides, "Vector39391893")}
                  ></Icon>
                  <Icon
                    width="47.92px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 47.91972351074219,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M46.2211 0L47.9197 0L47.9197 41.3994L46.2211 41.3994L46.2211 0ZM0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.74%"
                    right="18.83%"
                    {...getOverrideProps(overrides, "Vector39391894")}
                  ></Icon>
                  <Icon
                    width="1.7px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 1.6986329555511475,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M0 0L1.69863 0L1.69863 41.3994L0 41.3994L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.42%"
                    right="78.4%"
                    {...getOverrideProps(overrides, "Vector39391895")}
                  ></Icon>
                  <Icon
                    width="46.22px"
                    height="1.72px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.22109603881836,
                      height: 1.721482515335083,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="73.18%"
                    bottom="24.61%"
                    left="19.74%"
                    right="21.01%"
                    {...getOverrideProps(overrides, "Vector39391896")}
                  ></Icon>
                </View>
                <Flex
                  gap="6px"
                  direction="column"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="flex-start"
                  grow="1"
                  shrink="1"
                  basis="0"
                  position="relative"
                  padding="0px 10px 0px 10px"
                  {...getOverrideProps(overrides, "dcViewRow39391897")}
                >
                  <Button
                    width="unset"
                    height="unset"
                    justifyContent="flex-start"
                    padding="0px 0px 0px 0px"
                    shrink="0"
                    size="small"
                    isDisabled={false}
                    variation="link"
                    children="MRI_Brain_Scan_Left_View"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentTitle39391898"
                    )}
                  ></Button>
                  <Text
                    fontFamily="Inter"
                    fontSize="12px"
                    fontWeight="600"
                    color="rgba(0,85,102,1)"
                    lineHeight="12px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    alignSelf="stretch"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Type: Video"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentType39391899"
                    )}
                  ></Text>
                  <Flex
                    gap="6px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentActions39391901"
                    )}
                  >
                    <MyIcon
                      width="24px"
                      height="24px"
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      overflow="hidden"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      type="delete"
                      {...getOverrideProps(overrides, "dcIconDelete39391902")}
                    ></MyIcon>
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "dvcAttachmentItem40229392")}
              >
                <View
                  width="78px"
                  height="78px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "dvcAttachmentIcon40229393")}
                >
                  <Icon
                    width="46.41px"
                    height="39.34px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.411521911621094,
                      height: 39.3427734375,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.4115 0L46.4115 39.3428L0 39.3428L0 0Z",
                        fill: "rgba(225,240,255,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="23.42%"
                    bottom="26.14%"
                    left="20.75%"
                    right="19.75%"
                    {...getOverrideProps(overrides, "Vector40229394")}
                  ></Icon>
                  <Icon
                    width="39.04px"
                    height="21.39px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 39.0380859375,
                      height: 21.38906478881836,
                    }}
                    paths={[
                      {
                        d: "M1.27207 21.1453L0 19.8885L18.9668 0L39.0381 20.0941L37.8117 21.3891L19.0125 2.54414L1.27207 21.1453Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="47.7%"
                    bottom="24.88%"
                    left="20.78%"
                    right="29.17%"
                    {...getOverrideProps(overrides, "Vector40229395")}
                  ></Icon>
                  <Icon
                    width="19.98px"
                    height="13.56px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 19.979881286621094,
                      height: 13.55859375,
                    }}
                    paths={[
                      {
                        d: "M18.8449 13.5586L5.88047 2.45274C4.35703 4.01426 1.43203 7.01543 1.11972 7.26679L0.00761533 5.85761L0 5.86523C0.304688 5.59863 3.34394 2.49082 5.1873 0.59414L5.76621 0L19.9799 12.1799L18.8449 13.5586Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="50.8%"
                    bottom="31.82%"
                    left="54.63%"
                    right="19.76%"
                    {...getOverrideProps(overrides, "Vector40229396")}
                  ></Icon>
                  <Icon
                    width="7.53px"
                    height="7.65px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 7.52578067779541,
                      height: 7.647657871246338,
                    }}
                    paths={[
                      {
                        d: "M0 3.82383C0 4.83797 0.396442 5.81058 1.10212 6.52768C1.8078 7.24479 2.76491 7.64766 3.76289 7.64766C4.76087 7.64766 5.71798 7.24479 6.42365 6.52768C7.12933 5.81058 7.52578 4.83797 7.52578 3.82383C7.52578 2.80969 7.12933 1.83708 6.42365 1.11997C5.71798 0.402867 4.76087 0 3.76289 0C2.76491 0 1.8078 0.402867 1.10212 1.11997C0.396442 1.83708 0 2.80969 0 3.82383Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="31.67%"
                    bottom="58.53%"
                    left="59.61%"
                    right="30.74%"
                    {...getOverrideProps(overrides, "Vector40229397")}
                  ></Icon>
                  <Icon
                    width="47.92px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 47.91972351074219,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M46.2211 0L47.9197 0L47.9197 41.3994L46.2211 41.3994L46.2211 0ZM0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.74%"
                    right="18.83%"
                    {...getOverrideProps(overrides, "Vector40229398")}
                  ></Icon>
                  <Icon
                    width="1.7px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 1.6986329555511475,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M0 0L1.69863 0L1.69863 41.3994L0 41.3994L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.42%"
                    right="78.4%"
                    {...getOverrideProps(overrides, "Vector40229399")}
                  ></Icon>
                  <Icon
                    width="46.22px"
                    height="1.72px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.22109603881836,
                      height: 1.721482515335083,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="73.18%"
                    bottom="24.61%"
                    left="19.74%"
                    right="21.01%"
                    {...getOverrideProps(overrides, "Vector40229400")}
                  ></Icon>
                </View>
                <Flex
                  gap="6px"
                  direction="column"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="flex-start"
                  grow="1"
                  shrink="1"
                  basis="0"
                  position="relative"
                  padding="0px 10px 0px 10px"
                  {...getOverrideProps(overrides, "dcViewRow40229401")}
                >
                  <Button
                    width="unset"
                    height="unset"
                    justifyContent="flex-start"
                    padding="0px 0px 0px 0px"
                    shrink="0"
                    size="small"
                    isDisabled={false}
                    variation="link"
                    children="MIR_Image1"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentTitle40229402"
                    )}
                  ></Button>
                  <Text
                    fontFamily="Inter"
                    fontSize="12px"
                    fontWeight="600"
                    color="rgba(0,85,102,1)"
                    lineHeight="12px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    alignSelf="stretch"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Type: Image"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentType40229403"
                    )}
                  ></Text>
                  <Flex
                    gap="6px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentActions40229404"
                    )}
                  >
                    <MyIcon
                      width="24px"
                      height="24px"
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      overflow="hidden"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      type="delete"
                      {...getOverrideProps(overrides, "dcIconDelete40229405")}
                    ></MyIcon>
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "dvcAttachmentItem40229470")}
              >
                <View
                  width="78px"
                  height="78px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "dvcAttachmentIcon40229471")}
                >
                  <Icon
                    width="46.41px"
                    height="39.34px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.411521911621094,
                      height: 39.3427734375,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.4115 0L46.4115 39.3428L0 39.3428L0 0Z",
                        fill: "rgba(225,240,255,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="23.42%"
                    bottom="26.14%"
                    left="20.75%"
                    right="19.75%"
                    {...getOverrideProps(overrides, "Vector40229472")}
                  ></Icon>
                  <Icon
                    width="39.04px"
                    height="21.39px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 39.0380859375,
                      height: 21.38906478881836,
                    }}
                    paths={[
                      {
                        d: "M1.27207 21.1453L0 19.8885L18.9668 0L39.0381 20.0941L37.8117 21.3891L19.0125 2.54414L1.27207 21.1453Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="47.7%"
                    bottom="24.88%"
                    left="20.78%"
                    right="29.17%"
                    {...getOverrideProps(overrides, "Vector40229473")}
                  ></Icon>
                  <Icon
                    width="19.98px"
                    height="13.56px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 19.979881286621094,
                      height: 13.55859375,
                    }}
                    paths={[
                      {
                        d: "M18.8449 13.5586L5.88047 2.45274C4.35703 4.01426 1.43203 7.01543 1.11972 7.26679L0.00761533 5.85761L0 5.86523C0.304688 5.59863 3.34394 2.49082 5.1873 0.59414L5.76621 0L19.9799 12.1799L18.8449 13.5586Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="50.8%"
                    bottom="31.82%"
                    left="54.63%"
                    right="19.76%"
                    {...getOverrideProps(overrides, "Vector40229474")}
                  ></Icon>
                  <Icon
                    width="7.53px"
                    height="7.65px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 7.52578067779541,
                      height: 7.647657871246338,
                    }}
                    paths={[
                      {
                        d: "M0 3.82383C0 4.83797 0.396442 5.81058 1.10212 6.52768C1.8078 7.24479 2.76491 7.64766 3.76289 7.64766C4.76087 7.64766 5.71798 7.24479 6.42365 6.52768C7.12933 5.81058 7.52578 4.83797 7.52578 3.82383C7.52578 2.80969 7.12933 1.83708 6.42365 1.11997C5.71798 0.402867 4.76087 0 3.76289 0C2.76491 0 1.8078 0.402867 1.10212 1.11997C0.396442 1.83708 0 2.80969 0 3.82383Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="31.67%"
                    bottom="58.53%"
                    left="59.61%"
                    right="30.74%"
                    {...getOverrideProps(overrides, "Vector40229475")}
                  ></Icon>
                  <Icon
                    width="47.92px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 47.91972351074219,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M46.2211 0L47.9197 0L47.9197 41.3994L46.2211 41.3994L46.2211 0ZM0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.74%"
                    right="18.83%"
                    {...getOverrideProps(overrides, "Vector40229476")}
                  ></Icon>
                  <Icon
                    width="1.7px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 1.6986329555511475,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M0 0L1.69863 0L1.69863 41.3994L0 41.3994L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.42%"
                    right="78.4%"
                    {...getOverrideProps(overrides, "Vector40229477")}
                  ></Icon>
                  <Icon
                    width="46.22px"
                    height="1.72px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.22109603881836,
                      height: 1.721482515335083,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="73.18%"
                    bottom="24.61%"
                    left="19.74%"
                    right="21.01%"
                    {...getOverrideProps(overrides, "Vector40229478")}
                  ></Icon>
                </View>
                <Flex
                  gap="6px"
                  direction="column"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="flex-start"
                  grow="1"
                  shrink="1"
                  basis="0"
                  position="relative"
                  padding="0px 10px 0px 10px"
                  {...getOverrideProps(overrides, "dcViewRow40229479")}
                >
                  <Button
                    width="unset"
                    height="unset"
                    justifyContent="flex-start"
                    padding="0px 0px 0px 0px"
                    shrink="0"
                    size="small"
                    isDisabled={false}
                    variation="link"
                    children="MIR_Image2"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentTitle40229480"
                    )}
                  ></Button>
                  <Text
                    fontFamily="Inter"
                    fontSize="12px"
                    fontWeight="600"
                    color="rgba(0,85,102,1)"
                    lineHeight="12px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    alignSelf="stretch"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Type: Image"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentType40229481"
                    )}
                  ></Text>
                  <Flex
                    gap="6px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentActions40229482"
                    )}
                  >
                    <MyIcon
                      width="24px"
                      height="24px"
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      overflow="hidden"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      type="delete"
                      {...getOverrideProps(overrides, "dcIconDelete40229483")}
                    ></MyIcon>
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "dvcAttachmentItem40229566")}
              >
                <View
                  width="78px"
                  height="78px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "dvcAttachmentIcon40229567")}
                >
                  <Icon
                    width="46.41px"
                    height="39.34px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.411521911621094,
                      height: 39.3427734375,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.4115 0L46.4115 39.3428L0 39.3428L0 0Z",
                        fill: "rgba(225,240,255,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="23.42%"
                    bottom="26.14%"
                    left="20.75%"
                    right="19.75%"
                    {...getOverrideProps(overrides, "Vector40229568")}
                  ></Icon>
                  <Icon
                    width="39.04px"
                    height="21.39px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 39.0380859375,
                      height: 21.38906478881836,
                    }}
                    paths={[
                      {
                        d: "M1.27207 21.1453L0 19.8885L18.9668 0L39.0381 20.0941L37.8117 21.3891L19.0125 2.54414L1.27207 21.1453Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="47.7%"
                    bottom="24.88%"
                    left="20.78%"
                    right="29.17%"
                    {...getOverrideProps(overrides, "Vector40229569")}
                  ></Icon>
                  <Icon
                    width="19.98px"
                    height="13.56px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 19.979881286621094,
                      height: 13.55859375,
                    }}
                    paths={[
                      {
                        d: "M18.8449 13.5586L5.88047 2.45274C4.35703 4.01426 1.43203 7.01543 1.11972 7.26679L0.00761533 5.85761L0 5.86523C0.304688 5.59863 3.34394 2.49082 5.1873 0.59414L5.76621 0L19.9799 12.1799L18.8449 13.5586Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="50.8%"
                    bottom="31.82%"
                    left="54.63%"
                    right="19.76%"
                    {...getOverrideProps(overrides, "Vector40229570")}
                  ></Icon>
                  <Icon
                    width="7.53px"
                    height="7.65px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 7.52578067779541,
                      height: 7.647657871246338,
                    }}
                    paths={[
                      {
                        d: "M0 3.82383C0 4.83797 0.396442 5.81058 1.10212 6.52768C1.8078 7.24479 2.76491 7.64766 3.76289 7.64766C4.76087 7.64766 5.71798 7.24479 6.42365 6.52768C7.12933 5.81058 7.52578 4.83797 7.52578 3.82383C7.52578 2.80969 7.12933 1.83708 6.42365 1.11997C5.71798 0.402867 4.76087 0 3.76289 0C2.76491 0 1.8078 0.402867 1.10212 1.11997C0.396442 1.83708 0 2.80969 0 3.82383Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="31.67%"
                    bottom="58.53%"
                    left="59.61%"
                    right="30.74%"
                    {...getOverrideProps(overrides, "Vector40229571")}
                  ></Icon>
                  <Icon
                    width="47.92px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 47.91972351074219,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M46.2211 0L47.9197 0L47.9197 41.3994L46.2211 41.3994L46.2211 0ZM0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.74%"
                    right="18.83%"
                    {...getOverrideProps(overrides, "Vector40229572")}
                  ></Icon>
                  <Icon
                    width="1.7px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 1.6986329555511475,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M0 0L1.69863 0L1.69863 41.3994L0 41.3994L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.42%"
                    right="78.4%"
                    {...getOverrideProps(overrides, "Vector40229573")}
                  ></Icon>
                  <Icon
                    width="46.22px"
                    height="1.72px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.22109603881836,
                      height: 1.721482515335083,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="73.18%"
                    bottom="24.61%"
                    left="19.74%"
                    right="21.01%"
                    {...getOverrideProps(overrides, "Vector40229574")}
                  ></Icon>
                </View>
                <Flex
                  gap="6px"
                  direction="column"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="flex-start"
                  grow="1"
                  shrink="1"
                  basis="0"
                  position="relative"
                  padding="0px 10px 0px 10px"
                  {...getOverrideProps(overrides, "dcViewRow40229575")}
                >
                  <Button
                    width="unset"
                    height="unset"
                    justifyContent="flex-start"
                    padding="0px 0px 0px 0px"
                    shrink="0"
                    size="small"
                    isDisabled={false}
                    variation="link"
                    children="MIR_Image3"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentTitle40229576"
                    )}
                  ></Button>
                  <Text
                    fontFamily="Inter"
                    fontSize="12px"
                    fontWeight="600"
                    color="rgba(0,85,102,1)"
                    lineHeight="12px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    alignSelf="stretch"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Type: Image"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentType40229577"
                    )}
                  ></Text>
                  <Flex
                    gap="6px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentActions40229578"
                    )}
                  >
                    <MyIcon
                      width="24px"
                      height="24px"
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      overflow="hidden"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      type="delete"
                      {...getOverrideProps(overrides, "dcIconDelete40229579")}
                    ></MyIcon>
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "dvcAttachmentItem40229680")}
              >
                <View
                  width="78px"
                  height="78px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "dvcAttachmentIcon40229681")}
                >
                  <Icon
                    width="46.41px"
                    height="39.34px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.411521911621094,
                      height: 39.3427734375,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.4115 0L46.4115 39.3428L0 39.3428L0 0Z",
                        fill: "rgba(225,240,255,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="23.42%"
                    bottom="26.14%"
                    left="20.75%"
                    right="19.75%"
                    {...getOverrideProps(overrides, "Vector40229682")}
                  ></Icon>
                  <Icon
                    width="39.04px"
                    height="21.39px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 39.0380859375,
                      height: 21.38906478881836,
                    }}
                    paths={[
                      {
                        d: "M1.27207 21.1453L0 19.8885L18.9668 0L39.0381 20.0941L37.8117 21.3891L19.0125 2.54414L1.27207 21.1453Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="47.7%"
                    bottom="24.88%"
                    left="20.78%"
                    right="29.17%"
                    {...getOverrideProps(overrides, "Vector40229683")}
                  ></Icon>
                  <Icon
                    width="19.98px"
                    height="13.56px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 19.979881286621094,
                      height: 13.55859375,
                    }}
                    paths={[
                      {
                        d: "M18.8449 13.5586L5.88047 2.45274C4.35703 4.01426 1.43203 7.01543 1.11972 7.26679L0.00761533 5.85761L0 5.86523C0.304688 5.59863 3.34394 2.49082 5.1873 0.59414L5.76621 0L19.9799 12.1799L18.8449 13.5586Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="50.8%"
                    bottom="31.82%"
                    left="54.63%"
                    right="19.76%"
                    {...getOverrideProps(overrides, "Vector40229684")}
                  ></Icon>
                  <Icon
                    width="7.53px"
                    height="7.65px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 7.52578067779541,
                      height: 7.647657871246338,
                    }}
                    paths={[
                      {
                        d: "M0 3.82383C0 4.83797 0.396442 5.81058 1.10212 6.52768C1.8078 7.24479 2.76491 7.64766 3.76289 7.64766C4.76087 7.64766 5.71798 7.24479 6.42365 6.52768C7.12933 5.81058 7.52578 4.83797 7.52578 3.82383C7.52578 2.80969 7.12933 1.83708 6.42365 1.11997C5.71798 0.402867 4.76087 0 3.76289 0C2.76491 0 1.8078 0.402867 1.10212 1.11997C0.396442 1.83708 0 2.80969 0 3.82383Z",
                        fill: "rgba(109,158,232,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="31.67%"
                    bottom="58.53%"
                    left="59.61%"
                    right="30.74%"
                    {...getOverrideProps(overrides, "Vector40229685")}
                  ></Icon>
                  <Icon
                    width="47.92px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 47.91972351074219,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M46.2211 0L47.9197 0L47.9197 41.3994L46.2211 41.3994L46.2211 0ZM0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.74%"
                    right="18.83%"
                    {...getOverrideProps(overrides, "Vector40229686")}
                  ></Icon>
                  <Icon
                    width="1.7px"
                    height="41.4px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 1.6986329555511475,
                      height: 41.3994140625,
                    }}
                    paths={[
                      {
                        d: "M0 0L1.69863 0L1.69863 41.3994L0 41.3994L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="22.31%"
                    bottom="24.61%"
                    left="19.42%"
                    right="78.4%"
                    {...getOverrideProps(overrides, "Vector40229687")}
                  ></Icon>
                  <Icon
                    width="46.22px"
                    height="1.72px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 46.22109603881836,
                      height: 1.721482515335083,
                    }}
                    paths={[
                      {
                        d: "M0 0L46.2211 0L46.2211 1.72148L0 1.72148L0 0Z",
                        fill: "rgba(68,110,177,1)",
                        fillRule: "nonzero",
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="73.18%"
                    bottom="24.61%"
                    left="19.74%"
                    right="21.01%"
                    {...getOverrideProps(overrides, "Vector40229688")}
                  ></Icon>
                </View>
                <Flex
                  gap="6px"
                  direction="column"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="flex-start"
                  grow="1"
                  shrink="1"
                  basis="0"
                  position="relative"
                  padding="0px 10px 0px 10px"
                  {...getOverrideProps(overrides, "dcViewRow40229689")}
                >
                  <Button
                    width="unset"
                    height="unset"
                    justifyContent="flex-start"
                    padding="0px 0px 0px 0px"
                    shrink="0"
                    size="small"
                    isDisabled={false}
                    variation="link"
                    children="MIR_Image4"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentTitle40229690"
                    )}
                  ></Button>
                  <Text
                    fontFamily="Inter"
                    fontSize="12px"
                    fontWeight="600"
                    color="rgba(0,85,102,1)"
                    lineHeight="12px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    alignSelf="stretch"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Type: Image"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentType40229691"
                    )}
                  ></Text>
                  <Flex
                    gap="6px"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="center"
                    alignItems="center"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    {...getOverrideProps(
                      overrides,
                      "dvcAttachmentActions40229692"
                    )}
                  >
                    <MyIcon
                      width="24px"
                      height="24px"
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      overflow="hidden"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                      type="delete"
                      {...getOverrideProps(overrides, "dcIconDelete40229693")}
                    ></MyIcon>
                  </Flex>
                </Flex>
              </Flex>
              <Button
                width="unset"
                height="unset"
                shrink="0"
                alignSelf="stretch"
                size="small"
                isDisabled={false}
                variation="primary"
                children="Add Attachment"
                {...getOverrideProps(overrides, "dvcAddAttachmentButton")}
              ></Button>
              <Button
                width="unset"
                height="unset"
                shrink="0"
                alignSelf="stretch"
                size="small"
                isDisabled={false}
                variation="primary"
                children="Preview Files"
                {...getOverrideProps(overrides, "dvcPreviewButton")}
              ></Button>
            </Flex>
          </Flex>
        </Flex>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          {...getOverrideProps(overrides, "dvcDivider40218658")}
        ></Divider>
        <Flex
          gap="16px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "dvcNoteFrame1")}
        >
          <MyIcon
            width="24px"
            height="24px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            type="chat"
            {...getOverrideProps(overrides, "vcNoteIcon1")}
          ></MyIcon>
          <Text
            fontFamily="Inter"
            fontSize="16px"
            fontWeight="400"
            color="rgba(48,64,80,1)"
            lineHeight="24px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="0.01px"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            grow="1"
            shrink="1"
            basis="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="@BrandonCarranza(Immunologist)&#xA;“I watched the MRI and looks like we found something; I asked for CBC and ANA labs to add more details...”&#xA;[03/02/2024]"
            {...getOverrideProps(overrides, "vcNote1")}
          ></Text>
        </Flex>
        <Button
          width="unset"
          height="unset"
          shrink="0"
          size="small"
          isDisabled={false}
          variation="primary"
          children="Save"
          {...getOverrideProps(overrides, "dvcSaveButton")}
        ></Button>
      </Flex>
    </Flex>
  );
}
